export const REDUCER_NAME = 'uploads';
